<div class="relative">
  <svc-chip-grouped
    [label]="label ?? ('Lugar' | transloco)"
    [formControl]="formControl"
    [options]="options"
    [loading]="isLoading"
    [inputId]="inputId"
    [readonly]="readonly"
    [fallbackTextValue]="fallbackTextValue"
    [placeholder]="placeholder"
    [showValidation]="showValidation"
    type="single"
  >
    <ng-template
      let-option="option"
      let-rederingInList="rederingInList"
    >
      {{ option.label }}
      <p
        *ngIf="rederingInList"
        class="text-xs opacity-60"
      >
        {{ option.data?.groupDescription }}
      </p>
    </ng-template>
  </svc-chip-grouped>

  @if (!readonly) {
    <button
      svc-btn-icon
      id="svc-location-field-button-open-modal-locations"
      class="absolute right-7 max-w-7 max-h-7 rounded-full"
      [ngClass]="(label ?? ('Lugar' | transloco)) ? 'top-8' : 'top-2'"
      icon="mat_solid:search"
      [iconSize]="5"
      [disabled]="isLoading || formControl?.disabled"
      (click)="openDialog()"
    ></button>
  }
</div>
